import { Injectable } from '@angular/core';
import { doc, Firestore, getDoc, setDoc } from '@angular/fire/firestore';
import { ScoreValue } from '../models/score-value';

@Injectable()
export class ScoreService {
  constructor(
    private firestore: Firestore
  ) {}

  async readAsync(itemId: string, studentId: string) {
    // This method should return an observable of one score value
    // It can be implemented to fetch score values from a Firestore collection
    // For example:
    const scoreValueDocRef = doc(this.firestore, `scoreValues/${itemId}-${studentId}`);
    const docSnapshot = await getDoc(scoreValueDocRef);
    if (docSnapshot.exists()) {
      return docSnapshot.data() as ScoreValue;
    }
    else {
      return new ScoreValue(); // Return an empty ScoreValue if it does not exist
    }
  }

  async createOrUpdateAsync(itemId: string, studentId: string, value: string) {
    const scoreValueDocRef = doc(this.firestore, `scoreValues/${itemId}-${studentId}`);
    await setDoc(scoreValueDocRef, {
      itemId: itemId,
      studentId: studentId,
      value: value
    });
  }

}
